import { InformationCircleIcon } from '@heroicons/react/24/outline'
import { ElementType, ReactNode, useRef } from 'react'

import cn from '@/utilities/cn'

type PopoverProps = {
  tooltipMessage?: string
  tooltipHeader?: string
  onClick?: () => void
  icon?: ReactNode
  className?: string
  as?: ElementType
  background?: 'brand' | 'zinc'
  tooltipContent?: ReactNode
}

export const Popover = ({
  tooltipMessage,
  tooltipHeader,
  onClick = () => {},
  icon,
  className,
  as = 'button',
  background = 'zinc',
  tooltipContent
}: PopoverProps) => {
  const tooltipRef = useRef<HTMLDivElement>(null)
  const container = useRef<HTMLButtonElement>(null)
  const Component = as

  return (
    <Component
      ref={container}
      onMouseEnter={({ clientX }: any) => {
        if (!tooltipRef.current || !container.current) return
        const { left } = container.current.getBoundingClientRect()
        const dropdownRect = tooltipRef.current.getBoundingClientRect()
        if (dropdownRect.x + dropdownRect.width > window.innerWidth) {
          tooltipRef.current.style.right = '0'
        } else {
          tooltipRef.current.style.left = clientX - left - 80 + 'px'
        }
      }}
      className={cn('group relative inline-block', className)}
      onClick={onClick}
    >
      <div className="relative flex items-center pl-1">
        {icon || (
          <InformationCircleIcon className="stroke-width-2 h-6 w-6 fill-brand-50/50 stroke-brand-400 hover:cursor-pointer hover:stroke-brand-200" />
        )}
      </div>
      <div
        className={cn(
          'invisible absolute top-full z-50 mt-3 w-72 rounded-md p-4 text-left opacity-0 shadow-lg transition group-hover:visible group-hover:opacity-100',
          { 'bg-zinc-50': background === 'zinc', 'bg-brand-800': background === 'brand' }
        )}
        ref={tooltipRef}
      >
        {tooltipHeader && (
          <div
            className={cn('text-base font-semibold leading-6 text-zinc-900', {
              'text-brand-50': background === 'brand'
            })}
          >
            {tooltipHeader}
          </div>
        )}
        {tooltipMessage && (
          <p
            className={cn('text-sm font-normal text-zinc-500', {
              'text-brand-50': background === 'brand',
              'mt-2': tooltipHeader
            })}
          >
            {tooltipMessage}
          </p>
        )}
        {tooltipContent && tooltipContent}
      </div>
    </Component>
  )
}
